import { render, staticRenderFns } from "./BankInformationForm.vue?vue&type=template&id=ffa6c9c8&scoped=true"
import script from "./BankInformationForm.vue?vue&type=script&lang=js"
export * from "./BankInformationForm.vue?vue&type=script&lang=js"
import style0 from "./BankInformationForm.vue?vue&type=style&index=0&id=ffa6c9c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa6c9c8",
  null
  
)

export default component.exports